module.exports.scrubMixin = scrubMixin

function scrubMixin () {
  return {
    methods: {
      scrub: function (slug) {
        return encodeURIComponent(slug)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins.js